module.exports = __webpack_public_path__ + "img/NOW-Bali-967x683.fc99b8ce.png";